export enum ElementItemsSortMode {
    Alphabetic = 0,
    SortNr = 1,
}